"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var draft_groups_1 = __importDefault(require("../constants/actions/draft-groups"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    list: [],
    error_id: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case draft_groups_1.default.INIT:
      return Object.assign({}, state, {
        list: action.list
      });

    case draft_groups_1.default.ADD:
      return Object.assign({}, state, {
        list: lodash_1.default.concat(state.list, action.group)
      });

    case draft_groups_1.default.EDIT:
      return Object.assign({}, state, {
        list: state.list.map(function (v) {
          if (v.id === action.id) {
            return action.group;
          } else {
            return v;
          }
        })
      });

    case draft_groups_1.default.REMOVE_INIT:
      return Object.assign({}, state, {
        error_id: null
      });

    case draft_groups_1.default.REMOVE_SUCCESS:
      return Object.assign({}, state, {
        list: lodash_1.default.filter(state.list, function (v) {
          return v.id !== action.id;
        })
      });

    case draft_groups_1.default.REMOVE_FAILURE:
      return Object.assign({}, state, {
        error_id: action.error_id
      });

    default:
      return state;
  }
}

exports.default = default_1;